import { isArray as j, isEqual as ii } from "../util/code-utils.js";
import ti from "../models/push-token.js";
import { logger as r, EncodingUtils as ei } from "../../shared-lib/index.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
import { WindowUtils as eo } from "../util/window-utils.js";
import vt from "./utils/push-utils.js";
import { getErrorMessage as si } from "../util/error-utils.js";
export default class ea {
  constructor(i, t, e, s, r, n, o, u, a, c) {
    (this.sn = i),
      (this.rn = t),
      (this.on = e),
      (this.un = r),
      (this.an = n),
      (this.yt = o),
      (this.cn = u),
      (this.hn = a),
      (this.u = c),
      (this.sn = i),
      (this.rn = t),
      (this.on = e),
      (this.fn = s + "/safari/" + t),
      (this.un = r || "/service-worker.js"),
      (this.an = n),
      (this.yt = o),
      (this.cn = u || !1),
      (this.hn = a || !1),
      (this.u = c),
      (this.ln = vt.dn()),
      (this.pn = vt.bn());
  }
  mn() {
    return this.hn;
  }
  yn(i, t, e, s, n) {
    i.unsubscribe()
      .then((i) => {
        i
          ? this.vn(t, e, s, n)
          : (r.error("Failed to unsubscribe device from push."),
            "function" == typeof n && n(!1));
      })
      .catch((i) => {
        r.error("Push unsubscription error: " + i),
          "function" == typeof n && n(!1);
      });
  }
  gn(i, t, e) {
    var s;
    const n = ((i) => {
      if ("string" == typeof i) return i;
      if (0 !== i.endpoint.indexOf("https://android.googleapis.com/gcm/send"))
        return i.endpoint;
      let t = i.endpoint;
      const e = i;
      return (
        e.wn &&
          -1 === i.endpoint.indexOf(e.wn) &&
          (t = i.endpoint + "/" + e.wn),
        t
      );
    })(i);
    let o = null,
      u = null;
    const a = i;
    if (null != a.getKey)
      try {
        const i = Array.from(new Uint8Array(a.getKey("p256dh"))),
          t = Array.from(new Uint8Array(a.getKey("auth")));
        (o = btoa(String.fromCharCode.apply(null, i))),
          (u = btoa(String.fromCharCode.apply(null, t)));
      } catch (i) {
        r.error(si(i));
      }
    const c = ((i) => {
      let t;
      return i.options &&
        (t = i.options.applicationServerKey) &&
        t.byteLength &&
        t.byteLength > 0
        ? btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(t))))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
        : null;
    })(a);
    null === (s = this.sn) || void 0 === s || s.kn(n, t, o, u, c),
      n && "function" == typeof e && e(n, o, u);
  }
  Pn() {
    var i;
    null === (i = this.sn) || void 0 === i || i.Dn(!0);
  }
  Sn(i, t) {
    var e;
    null === (e = this.sn) || void 0 === e || e.Dn(!1),
      r.info(i),
      "function" == typeof t && t(!1);
  }
  An(i, t, e, s) {
    var n;
    if ("default" === t.permission)
      try {
        window.safari.pushNotification.requestPermission(
          this.fn,
          i,
          {
            api_key: this.rn,
            device_id:
              (null === (n = this.on) || void 0 === n ? void 0 : n.ce().id) ||
              "",
          },
          (t) => {
            "granted" === t.permission &&
              this.sn &&
              this.sn.setPushNotificationSubscriptionType(
                User.NotificationSubscriptionTypes.OPTED_IN,
              ),
              this.An(i, t, e, s);
          },
        );
      } catch (i) {
        this.Sn("Could not request permission for push: " + i, s);
      }
    else
      "denied" === t.permission
        ? this.Sn(
            "The user has blocked notifications from this site, or Safari push is not configured in the Braze dashboard.",
            s,
          )
        : "granted" === t.permission &&
          (r.info("Device successfully subscribed to push."),
          this.gn(t.deviceToken, new Date(), e));
  }
  requestPermission(i, t, e) {
    const s = (s) => {
      switch (s) {
        case "granted":
          return void ("function" == typeof i && i());
        case "default":
          return void ("function" == typeof t && t());
        case "denied":
          return void ("function" == typeof e && e());
        default:
          r.error("Received unexpected permission result " + s);
      }
    };
    let n = !1;
    if ("default" !== window.Notification.permission)
      s(Notification.permission);
    else {
      const i = window.Notification.requestPermission((i) => {
        n && s(i);
      });
      i
        ? i.then((i) => {
            s(i);
          })
        : (n = !0);
    }
  }
  vn(i, t, e, s) {
    const n = { userVisibleOnly: !0 };
    null != t && (n.applicationServerKey = t),
      i.pushManager
        .subscribe(n)
        .then((i) => {
          r.info("Device successfully subscribed to push."),
            this.gn(i, new Date(), e);
        })
        .catch((i) => {
          vt.isPushBlocked()
            ? (r.info("Permission for push notifications was denied."),
              "function" == typeof s && s(!1))
            : (r.error("Push subscription failed: " + i),
              "function" == typeof s && s(!0));
        });
  }
  jn() {
    return this.cn
      ? navigator.serviceWorker.getRegistration(this.un)
      : navigator.serviceWorker.register(this.un).then(() =>
          navigator.serviceWorker.ready.then(
            (i) => (
              i &&
                "function" == typeof i.update &&
                i.update().catch((i) => {
                  r.info("ServiceWorker update failed: " + i);
                }),
              i
            ),
          ),
        );
  }
  xn(i) {
    this.cn ||
      (i.unregister(), r.info("Service worker successfully unregistered."));
  }
  subscribe(i, t) {
    if (!vt.isPushSupported())
      return r.info(ea.Nn), void ("function" == typeof t && t(!1));
    if (this.ln) {
      if (!this.cn && null != window.location) {
        let i = this.un;
        -1 === i.indexOf(window.location.host) &&
          (i = window.location.host + i),
          -1 === i.indexOf(window.location.protocol) &&
            (i = window.location.protocol + "//" + i);
        const e = i.substr(0, i.lastIndexOf("/") + 1);
        if (0 !== eo.Un().indexOf(e))
          return (
            r.error(
              "Cannot subscribe to push from a path higher than the service worker location (tried to subscribe from " +
                window.location.pathname +
                " but service worker is at " +
                i +
                ")",
            ),
            void ("function" == typeof t && t(!0))
          );
      }
      if (vt.isPushBlocked())
        return void this.Sn(
          "Notifications from this site are blocked. This may be a temporary embargo or a permanent denial.",
          t,
        );
      if (this.yt && !this.yt.Wn() && 0 === this.yt.ii())
        return (
          r.info(
            "Waiting for VAPID key from server config before subscribing to push.",
          ),
          void this.yt._n(() => {
            this.subscribe(i, t);
          })
        );
      const e = () => {
          r.info("Permission for push notifications was denied."),
            "function" == typeof t && t(!1);
        },
        s = () => {
          let i = "Permission for push notifications was ignored.";
          vt.isPushBlocked() &&
            (i +=
              " The browser has automatically blocked further permission requests for a period (probably 1 week)."),
            r.info(i),
            "function" == typeof t && t(!0);
        },
        n = vt.isPushPermissionGranted(),
        u = () => {
          !n &&
            this.sn &&
            this.sn.setPushNotificationSubscriptionType(
              User.NotificationSubscriptionTypes.OPTED_IN,
            ),
            this.jn()
              .then((e) => {
                if (null == e)
                  return (
                    r.error(
                      "No service worker registration. Set the `manageServiceWorkerExternally` initialization option to false or ensure that your service worker is registered before calling registerPush.",
                    ),
                    void ("function" == typeof t && t(!0))
                  );
                e.pushManager
                  .getSubscription()
                  .then((s) => {
                    var n;
                    let u = null;
                    if (
                      (null !=
                        (null === (n = this.yt) || void 0 === n
                          ? void 0
                          : n.Wn()) && (u = ei.Tn(this.yt.Wn())),
                      s)
                    ) {
                      let n,
                        a = null,
                        c = null;
                      if ((this.u && (n = this.u.j(o.C.In)), n && !j(n))) {
                        let i;
                        try {
                          i = ti.qn(n).Vn;
                        } catch (t) {
                          i = null;
                        }
                        null == i ||
                          isNaN(i.getTime()) ||
                          0 === i.getTime() ||
                          ((a = i),
                          (c = new Date(a)),
                          c.setMonth(a.getMonth() + 6));
                      }
                      null != u &&
                      s.options &&
                      s.options.applicationServerKey &&
                      s.options.applicationServerKey.byteLength &&
                      s.options.applicationServerKey.byteLength > 0 &&
                      !ii(u, new Uint8Array(s.options.applicationServerKey))
                        ? (s.options.applicationServerKey.byteLength > 12
                            ? r.info(
                                "Device was already subscribed to push using a different VAPID provider, creating new subscription.",
                              )
                            : r.info(
                                "Attempting to upgrade a gcm_sender_id-based push registration to VAPID - depending on the browser this may or may not result in the same gcm_sender_id-based subscription.",
                              ),
                          this.yn(s, e, u, i, t))
                        : s.expirationTime &&
                          new Date(s.expirationTime).valueOf() <=
                            new Date().valueOf()
                        ? (r.info(
                            "Push subscription is expired, creating new subscription.",
                          ),
                          this.yn(s, e, u, i, t))
                        : n && j(n)
                        ? this.yn(s, e, u, i, t)
                        : null == c
                        ? (r.info(
                            "No push subscription creation date found, creating new subscription.",
                          ),
                          this.yn(s, e, u, i, t))
                        : c.valueOf() <= new Date().valueOf()
                        ? (r.info(
                            "Push subscription older than 6 months, creating new subscription.",
                          ),
                          this.yn(s, e, u, i, t))
                        : (r.info(
                            "Device already subscribed to push, sending existing subscription to backend.",
                          ),
                          this.gn(s, a, i));
                    } else this.vn(e, u, i, t);
                  })
                  .catch((i) => {
                    r.error("Error checking current push subscriptions: " + i);
                  });
              })
              .catch((i) => {
                r.error("ServiceWorker registration failed: " + i);
              });
        };
      this.requestPermission(u, s, e);
    } else if (this.pn) {
      if (null == this.an || "" === this.an)
        return (
          r.error(
            "You must supply the safariWebsitePushId initialization option in order to use registerPush on Safari",
          ),
          void ("function" == typeof t && t(!0))
        );
      const e = window.safari.pushNotification.permission(this.an);
      this.An(this.an, e, i, t);
    }
  }
  unsubscribe(i, t) {
    if (!vt.isPushSupported())
      return r.info(ea.Nn), void ("function" == typeof t && t());
    this.ln
      ? navigator.serviceWorker.getRegistration(this.un).then((e) => {
          e
            ? e.pushManager
                .getSubscription()
                .then((s) => {
                  s
                    ? (this.Pn(),
                      s
                        .unsubscribe()
                        .then((s) => {
                          s
                            ? (r.info(
                                "Device successfully unsubscribed from push.",
                              ),
                              "function" == typeof i && i())
                            : (r.error(
                                "Failed to unsubscribe device from push.",
                              ),
                              "function" == typeof t && t()),
                            this.xn(e);
                        })
                        .catch((i) => {
                          r.error("Push unsubscription error: " + i),
                            "function" == typeof t && t();
                        }))
                    : (r.info("Device already unsubscribed from push."),
                      "function" == typeof i && i());
                })
                .catch((i) => {
                  r.error("Error unsubscribing from push: " + i),
                    "function" == typeof t && t();
                })
            : (r.info("Device already unsubscribed from push."),
              "function" == typeof i && i());
        })
      : this.pn &&
        (this.Pn(),
        r.info("Device unsubscribed from push."),
        "function" == typeof i && i());
  }
}
ea.Nn = "Push notifications are not supported in this browser.";
